import {
  Backdrop,
  Checkbox,
  CircularProgress,
  Grid,
  Box,
  TextField,
  Typography,
} from "@mui/material"
import React, { useState, useEffect } from "react"
import useStyles from "./useStyle"
import DatePicker from "react-datepicker"
import { es } from "date-fns/locale"
import DateRangeIcon from "@mui/icons-material/DateRange"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import {
  getAllGlobalNotification,
  getAllNotificationTypes,
  setRequestTypes,
  updateGlobalNotification,
} from "../../../redux/actions/GlobalNotification"
import { useDispatch, useSelector } from "react-redux"
import { logEvent } from "../../../utils/LogEvents"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../redux/actions/app"

// import { useNavigate } from 'react-router-dom'
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { useParams } from "react-router-dom"
import BreadcrumbsComponent from "../Breadcrumbs/Breadcrumbs"
import { addEntityGroupGlobalNotification } from "../../../redux/actions/eAuthz"
import { SelectNotificationConditions } from "../AddNotification/components/SelectNotificationConditions"
import { SelectSuborgGroups } from "../AddNotification/components/SelectSuborgGroups"
// import { useParams } from 'react-router-dom'
// import { useNavigate } from 'react-router-dom'

export const UpdateNotification = () => {
  const classes = useStyles()
  const [selectedFinishDate, setselectedFinishDate] = useState(null)
  const [selectedStartDate, setSelectedStartDate] = useState(null)
  const [editedType, setEditedType] = useState("")
  const [webappCheck, setwebappCheck] = useState(true)
  const [mobileApp, setmobileApp] = useState(true)
  // const [title, setTitle] = useState('')
  const [editedText, setEditedText] = useState("")
  const [notificationDetails, setnotificationDetail] = useState(null)
  const { types } = useSelector((state) => state.globalNotification)

  const formatTimeArg = (date) => {
    if (date) {
      const options = {
        timeZone: "America/Argentina/Buenos_Aires",
        hour: "2-digit",
        minute: "2-digit",
      }
      return new Date(date).toLocaleTimeString("es-AR", options)
    }
    return ""
  }

  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const dispatch = useDispatch()
  const { notificationId } = useParams()

  const [loading, setLoading] = useState(false)
  const [editedTitle, setEditedTitle] = useState("")
  const [startSuspendTime, setstartSuspendTime] = useState("")
  const [finishSuspendTime, setfinishSuspendTime] = useState("")
  const [checkSuspendNotification, setCheckSuspendNotification] =
    useState(false)
  const [selectedSuspendFinishtDate, setselectedSuspendFinishtDate] =
    useState(null)
  const [selectedStartDateSuspend, setSelectedSuspendStartDate] = useState(null)
  const [notificationCondSelect, setNotificationCondSelect] = useState("")
  const [suborganizationGroupSelect, setSuborganizationGroupSelect] =
    useState("")
  // inputs errors
  const [textError, settextError] = useState("")
  const [titleError, setTitleError] = useState(false)
  const [descriptionError, setdescriptionError] = useState(false)
  const [starDateError, setstarDateError] = useState(false)
  const [finishDateError, setfinishDateError] = useState(false)
  const [starDateSuspendError, setstarDateSuspendError] = useState(false)
  const [finishDateSuspendError, setfinishDateSuspendError] = useState(false)
  const [suborgGroupError, setsuborgGroupError] = useState(false)
  const [typeNotifCondError, settypeNotifCondError] = useState(false)
  // const [aplicationError, setaplicationError] = useState(false)
  const [plataformError, setplataformError] = useState(false)
  // const navigate = useNavigate()

  const fetchNotificationDetails = async () => {
    setLoading(true)
    try {
      const response = await dispatch(getAllGlobalNotification(["ME", "ME"]))

      if (Array.isArray(response) && response.length > 0) {
        const filteredNotification = response.find(
          (notification) => notification.notificationId === notificationId,
        )

        setLoading(false)

        if (filteredNotification) {
          setnotificationDetail(filteredNotification)
          setEditedTitle(filteredNotification.notificationTitle)
          setEditedText(filteredNotification.notificationText)
          setEditedType(filteredNotification.notificationTypeCode)
          setStartTime(formatTimeArg(filteredNotification.validityStartDate))
          setEndTime(formatTimeArg(filteredNotification.validityFinishDate))
          setSelectedStartDate(new Date(filteredNotification.validityStartDate))
          setselectedFinishDate(
            new Date(filteredNotification.validityFinishDate),
          )

          if (filteredNotification.communicationChannels) {
            setwebappCheck(
              filteredNotification.communicationChannels.some(
                (channel) =>
                  channel.communicationChannelCode === "WEB-APP-PUSH",
              ),
            )
            setmobileApp(
              filteredNotification.communicationChannels.some(
                (channel) =>
                  channel.communicationChannelCode === "MOBILE-APP-PUSH",
              ),
            )
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const loadTypes = async () => {
    await dispatch(getAllNotificationTypes())
  }
  useEffect(async () => {
    await fetchNotificationDetails()
    await updateGlobalNotification()
    loadTypes()
    return () => {
      dispatch(setRequestTypes())
    }
  }, [notificationId])

  const handleChangeSuborgGroup = (event) => {
    setSuborganizationGroupSelect(event.target.value)
  }
  const handleChangeNotificationConditions = (event) => {
    setNotificationCondSelect(event.target.value)
  }

  const handleFinishDateSuspendChange = (date) => {
    setselectedSuspendFinishtDate(date)
  }
  const handleStartDateSuspendChange = (date) => {
    setSelectedSuspendStartDate(date)
  }
  const handleStartTimeSuspendChange = (time) => {
    setstartSuspendTime(time)
  }

  const handleFinishTimeSuspendChange = (time) => {
    setfinishSuspendTime(time)
  }
  const handleChangeSelectSuspendNotification = () =>
    setCheckSuspendNotification(!checkSuspendNotification)
  const handleDateChange = (date) => {
    setselectedFinishDate(date)
  }

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date)
  }

  const handleStartTimeChange = (time) => {
    setStartTime(time)
  }

  const handleEndTimeChange = (time) => {
    setEndTime(time)
  }

  const handleChange = (event) => {
    setEditedType(event.target.value)
  }

  const handleChange2 = () => {
    setwebappCheck(!webappCheck)
  }

  const handleChange3 = () => {
    setmobileApp(!mobileApp)
  }

  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      <FormControlLabel
        label="Mi Estudio Web"
        control={
          <Checkbox
            checked={webappCheck}
            onChange={handleChange2}
            style={{
              color: "#026873",
              "&.MuiChecked": {
                color: "#03A696",
              },
            }}
          />
        }
      />
      <FormControlLabel
        label="Mi Estudio Mobile"
        control={
          <Checkbox
            checked={mobileApp}
            onChange={handleChange3}
            style={{
              color: "#026873",
              "&.MuiChecked": {
                color: "#03A696",
              },
            }}
          />
        }
      />
    </Box>
  )
  const isDateWithinRange = (start, end, dateToCheckStart, dateToCheckEnd) => {
    const startDate = new Date(start)
    const endDate = new Date(end)
    const dateToCheckStartDate = new Date(dateToCheckStart)
    const dateToCheckEndDate = new Date(dateToCheckEnd)

    // return dateToCheckStartDate >= startDate && dateToCheckEndDate <= endDate

    // Fecha de inicio antes y termina después de la fecha original
    if (dateToCheckStartDate < startDate && dateToCheckEndDate > endDate) {
      return false
    }

    // fecha inicia antes de la fecha original y termina antes
    if (
      dateToCheckEndDate > startDate &&
      dateToCheckStartDate < startDate &&
      dateToCheckEndDate < endDate
    ) {
      return false
    }

    // fecha inicia después de la fecha original y termina después
    if (dateToCheckStartDate >= startDate && dateToCheckStartDate <= endDate) {
      return false
    }

    return true
  }
  const isValidate = () => {
    setTitleError(false)
    setdescriptionError(false)
    setstarDateError(false)
    setfinishDateError(false)
    setplataformError(false)
    setstarDateSuspendError(false)
    setfinishDateSuspendError(false)
    setsuborgGroupError(false)
    settypeNotifCondError(false)
    if (editedTitle === "") {
      settextError("Ingrese un título")
      setTitleError(true)
      return false
    }
    if (editedText === "") {
      settextError("Ingrese una descripción")
      setdescriptionError(true)
      return false
    }
    if (!selectedStartDate) {
      settextError("Ingrese la fecha y hora de inicio")
      setstarDateError(true)
      return false
    }
    if (!selectedFinishDate) {
      settextError("Ingrese la fecha y hora de finalización")
      setfinishDateError(true)
      return false
    }
    if (!webappCheck && !mobileApp) {
      settextError("Seleccione la plataforma")
      setplataformError(true)
      return false
    }
    return true
  }

  const handleUpdateNotification = async () => {
    if (isValidate()) {
      try {
        const formatDateAndTime = (date, time) => {
          if (!date || !time) return null

          const [hours, minutes] = time.split(":")
          const newDate = new Date(date)
          newDate.setHours(Number(hours))
          newDate.setMinutes(Number(minutes))
          newDate.setSeconds(0)
          return newDate.toISOString()
        }
        const formattedStartDate = formatDateAndTime(
          selectedStartDate,
          startTime,
        )
        const formattedEndDate = formatDateAndTime(selectedFinishDate, endTime)

        const existingNotification = await dispatch(
          getAllGlobalNotification(["ME", "CGI"]),
        )

        if (existingNotification) {
          const isDuplicate = existingNotification.some(
            (notification) =>
              notification.notificationId !== notificationId &&
              notification.notificationTypeCode === editedType &&
              notification.applicationCode === "ME" &&
              !isDateWithinRange(
                notification.validityStartDate,
                notification.validityFinishDate,
                formattedStartDate,
                formattedEndDate,
              ) &&
              notification.isActive === true,
          )

          if (isDuplicate) {
            dispatch(setRequestTextSnackBar())
            dispatch(setErrorTextSnackBar("Ya existe una notificación"))
            return
          }
        }

        const body = {
          notificationId: notificationId,
          notificationTitle: editedTitle,
          notificationText: editedText,
          communicationChannelCodes: [],
          validityStartDate: formattedStartDate,
          validityFinishDate: formattedEndDate || null,
          isActive: true,
          appCode: "ME",
          notificationTypeCode: editedType,
        }

        webappCheck && body.communicationChannelCodes.push("WEB-APP-PUSH")
        mobileApp && body.communicationChannelCodes.push("MOBILE-APP-PUSH")

        if (body.validityStartDate < body.validityFinishDate) {
          if (
            body.notificationTitle &&
            body.notificationText &&
            body.appCode &&
            body.notificationTypeCode &&
            body.communicationChannelCodes
          ) {
            const newNotification = await dispatch(
              updateGlobalNotification(body),
            )

            logEvent("CGI - updateGlobalNotification", {
              body: {
                ...body,
              },
              response: newNotification,
            })
            if (!newNotification) {
              dispatch(setRequestTextSnackBar())
              dispatch(
                setErrorTextSnackBar(
                  "Ocurrió un error al crear la notificación",
                ),
              )
              return
            }
            let relatedNotificationId = newNotification?.notificationId
            if (
              (body.notificationTypeCode =
                "MAINTENANCE" && checkSuspendNotification)
            ) {
              if (!selectedStartDateSuspend) {
                settextError("Ingrese la fecha y hora de inicio")
                setstarDateSuspendError(true)
                return
              }
              if (!selectedSuspendFinishtDate) {
                settextError("Ingrese la fecha y hora de finalización")
                setfinishDateSuspendError(true)
                return
              }
              const formattedSuspendStartDate = formatDateAndTime(
                selectedStartDateSuspend,
                startSuspendTime,
              )
              const formattedSuspendEndDate = formatDateAndTime(
                selectedSuspendFinishtDate,
                finishSuspendTime,
              )
              if (!(formattedSuspendStartDate < formattedSuspendEndDate)) {
                setstarDateSuspendError(true)
                setfinishDateSuspendError(true)
                return settextError("Ingrese un rango horario valido")
              }
              console.log({
                ...body,
                relatedNotificationId,
                notificationTypeCode: "SERVICE_SUSPENSION",
                validityStartDate: formattedSuspendStartDate,
                validityFinishDate: formattedSuspendEndDate,
              })
              const newNotificationSuspend = await dispatch(
                updateGlobalNotification({
                  ...body,
                  relatedNotificationId,
                  notificationTypeCode: "SERVICE_SUSPENSION",
                  validityStartDate: formattedSuspendStartDate,
                  validityFinishDate: formattedSuspendEndDate,
                }),
              )
              if (!newNotificationSuspend) {
                dispatch(setRequestTextSnackBar())
                dispatch(
                  setErrorTextSnackBar(
                    "Ocurrió un error al crear la notificación de suspensión relacionada",
                  ),
                )
                return
              }
              relatedNotificationId = newNotificationSuspend?.notificationId
            }
            if (
              (notificationCondSelect && notificationCondSelect !== "") ||
              (suborganizationGroupSelect && suborganizationGroupSelect !== "")
            ) {
              if (!notificationCondSelect || notificationCondSelect === "") {
                settypeNotifCondError(true)
                return settextError("Seleccione el tipo de condición")
              }
              if (
                !suborganizationGroupSelect ||
                suborganizationGroupSelect === ""
              ) {
                setsuborgGroupError(true)
                return settextError("Seleccione el grupo de estudios")
              }
              const asociateNotificationSuspend = await dispatch(
                addEntityGroupGlobalNotification({
                  notificationId: relatedNotificationId,
                  notificationConditionType: notificationCondSelect,
                  suborganizationGroupId: suborganizationGroupSelect,
                }),
              )
              console.log(asociateNotificationSuspend)
              if (!asociateNotificationSuspend) {
                dispatch(setRequestTextSnackBar())
                dispatch(
                  setErrorTextSnackBar(
                    "La notificación fue creada exitosamente, excepto la asociación del tipo de condición",
                  ),
                )
                return
              }
            }

            dispatch(setRequestTextSnackBar())
            dispatch(setSuccessTextSnackBar("Modificación exitosa"))
            setTimeout(() => {
              window.location.href = "/globalNotification"
            }, 4000)
          }
        } else {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              "La fecha y horario de finalización deben ser posteriores a la de inicio",
            ),
          )
        }
      } catch (error) {
        console.log(error)
        // setIsError(true)
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error al crear la notificación"),
        )
      }
    }
  }

  return (
    <div>
      <BreadcrumbsComponent
        name={notificationDetails ? notificationDetails.notificationTitle : ""}
      />
      <Grid container className={classes.boxDetails}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {notificationDetails && (
          <>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  color: "#4B4952",
                  paddingLeft: 10,
                  borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
                }}
              >
                Editar notificación
              </Typography>
            </Grid>
            <Grid container style={{ padding: 10 }}>
              <Grid item xs={10}>
                <TextField
                  id="standard-basic"
                  label="Título"
                  variant="standard"
                  sx={{ width: "100%" }}
                  value={editedTitle}
                  onChange={(event) => setEditedTitle(event.target.value)}
                  error={titleError}
                  helperText={titleError && textError}
                />
              </Grid>

              <Grid item xs={10} style={{ paddingTop: 3 }}>
                <TextField
                  style={{ width: "100%" }}
                  id="standard-multiline-flexible"
                  label="Contenido"
                  multiline
                  rows={3}
                  variant="standard"
                  value={editedText}
                  onChange={(event) => setEditedText(event.target.value)}
                  error={descriptionError}
                  helperText={descriptionError && textError}
                />
              </Grid>

              <Grid container xs={12}>
                <Grid item xs={6}>
                  <Grid item xs={12} style={{ paddingTop: 10 }}>
                    <Typography
                      style={{
                        color: "#6e7a76",
                        marginTop: 10,
                        marginLeft: 5,
                        marginBottom: 5,
                        fontFamily: "Roboto",
                      }}
                    >
                      Fecha de inicio:
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "1px 1px 1px 1px",
                      }}
                    >
                      <DateRangeIcon
                        sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                      />
                      <div style={{ width: "80%", paddingLeft: 5 }}>
                        <div style={{ display: "flex" }}>
                          <Typography sx={{ color: "#6e7a76", width: "20%" }}>
                            Desde:
                          </Typography>
                          <div
                            style={{
                              width: "70%",
                              marginLeft: "6%",
                            }}
                          >
                            <DatePicker
                              id="date"
                              selected={selectedStartDate}
                              onChange={handleStartDateChange}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="dd/mm/aaaa"
                              showYearDropdown
                              scrollableYearDropdown
                              locale={es}
                              className={classes.dateSelector}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ paddingTop: 3 }}
                    className={classes.timeSelector}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "1px 1px 1px 1px",
                      }}
                    >
                      <AccessTimeIcon
                        sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                      />
                      <div style={{ width: "80%" }}>
                        <Grid style={{ display: "flex" }}>
                          <Typography
                            style={{
                              color: "#6e7a76",
                              marginTop: 10,
                              marginLeft: 5,
                              marginBottom: 5,
                              fontFamily: "Roboto",
                            }}
                          >
                            Horario:
                          </Typography>

                          <input
                            id="appt-time"
                            type="time"
                            name="appt-time"
                            value={startTime}
                            onChange={(event) =>
                              handleStartTimeChange(event.target.value)
                            }
                            style={{
                              marginLeft: "5%",
                              height: "30%",
                              marginTop: "2.5%",
                            }}
                          />
                        </Grid>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                {starDateError && (
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: "flex",
                      paddingTop: 10,
                      alignItems: "center",
                      fontWeight: "bold",
                      color: "#AD0707",
                    }}
                  >
                    {textError}
                  </Grid>
                )}
              </Grid>
              <Grid container xs={12}>
                <Grid item xs={6}>
                  <Grid item xs={12} style={{ paddingTop: 10 }}>
                    <Typography
                      style={{
                        color: "#6e7a76",
                        marginTop: 10,
                        marginLeft: 5,
                        marginBottom: 5,
                      }}
                    >
                      Fecha de finalización:
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "1px 1px 1px 1px",
                      }}
                    >
                      <DateRangeIcon
                        sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                      />
                      <div style={{ width: "80%", paddingLeft: 5 }}>
                        <div style={{ display: "flex" }}>
                          <Typography sx={{ color: "#6e7a76", width: "20%" }}>
                            Hasta:
                          </Typography>
                          <div
                            style={{
                              width: "70%",
                              marginLeft: "6%",
                            }}
                          >
                            <DatePicker
                              className={classes.dateSelector}
                              id="date2"
                              selected={selectedFinishDate}
                              onChange={handleDateChange}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="dd/mm/aaaa"
                              locale={es}
                              showYearDropdown
                              scrollableYearDropdown
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ paddingTop: 3 }}
                    className={classes.timeSelector}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "1px 1px 1px 1px",
                      }}
                    >
                      <AccessTimeIcon
                        sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                      />
                      <div style={{ width: "80%" }}>
                        <Grid style={{ display: "flex" }}>
                          <Typography
                            style={{
                              color: "#6e7a76",
                              marginTop: 10,
                              marginLeft: 5,
                              marginBottom: 5,
                              fontFamily: "Roboto",
                            }}
                          >
                            Horario:
                          </Typography>

                          <input
                            className={classes.timeSelector}
                            id="appt-time"
                            type="time"
                            name="appt-time"
                            value={endTime}
                            onChange={(event) =>
                              handleEndTimeChange(event.target.value)
                            }
                            style={{
                              marginLeft: "5%",
                              height: "30%",
                              marginTop: "2.5%",
                            }}
                          />
                        </Grid>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                {finishDateError && (
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: "flex",
                      paddingTop: 10,
                      alignItems: "center",
                      fontWeight: "bold",
                      color: "#AD0707",
                    }}
                  >
                    {textError}
                  </Grid>
                )}
              </Grid>

              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    color: "#6e7a76",
                    marginTop: 10,
                    marginLeft: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto",
                  }}
                >
                  Tipo de notificación:
                </Typography>
                <div style={{ display: "flex" }}>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 200,
                        color: "#00a78f",
                      }}
                    >
                      <CircularProgress color="inherit" />
                    </div>
                  ) : (
                    <>
                      <FormControl
                        variant="standard"
                        sx={{ m: 1, minWidth: 200 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={editedType}
                          onChange={handleChange}
                          label="Tipo"
                        >
                          {types &&
                            types.map((i) => (
                              <MenuItem
                                key={i.notificationTypeId}
                                value={i.notificationTypeCode}
                              >
                                {i.notificationTypeDesc}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      {editedType === "MAINTENANCE" && (
                        <div
                          style={{
                            display: "flex",
                            color: "#6e7a76",
                            alignItems: "center",
                            marginLeft: 15,
                          }}
                        >
                          <div>¿Es bloqueante?</div>
                          <Checkbox
                            checked={checkSuspendNotification}
                            onChange={handleChangeSelectSuspendNotification}
                            style={{
                              color: "#026873",
                              "&.MuiChecked": {
                                color: "#03A696",
                              },
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Grid>
              {editedType === "MAINTENANCE" && checkSuspendNotification && (
                <div style={{ width: "100%" }}>
                  <div>
                    <Typography
                      style={{
                        color: "#6e7a76",
                        padding: "5px 0px",
                        fontFamily: "Roboto",
                      }}
                    >
                      El servicio se suspenderá desde:
                    </Typography>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "5px 0px",
                        }}
                      >
                        <DateRangeIcon
                          sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                        />
                        <div style={{ width: "100%", paddingLeft: 5 }}>
                          <div style={{ display: "flex" }}>
                            <Typography sx={{ color: "#6e7a76", width: "12%" }}>
                              Fecha:
                            </Typography>

                            <DatePicker
                              id="date"
                              selected={selectedStartDateSuspend}
                              onChange={handleStartDateSuspendChange}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="dd/mm/aaaa"
                              showYearDropdown
                              scrollableYearDropdown
                              className={classes.dateSelector}
                              locale={es}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "5px 0px",
                        }}
                      >
                        <AccessTimeIcon
                          sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                        />

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Typography
                            style={{
                              color: "#6e7a76",
                              marginLeft: 5,
                              fontFamily: "Roboto",
                              width: "12%",
                            }}
                          >
                            Horario:
                          </Typography>

                          <div>
                            <input
                              id="appt-time"
                              type="time"
                              name="appt-time"
                              value={startSuspendTime}
                              onChange={(event) =>
                                handleStartTimeSuspendChange(event.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {starDateSuspendError && (
                      <Grid
                        item
                        xs={6}
                        style={{
                          display: "flex",
                          paddingTop: 10,
                          alignItems: "center",
                          fontWeight: "bold",
                          color: "#AD0707",
                        }}
                      >
                        {textError}
                      </Grid>
                    )}
                  </div>
                  <div>
                    <Typography
                      style={{
                        color: "#6e7a76",
                        fontFamily: "Roboto",
                        padding: "5px 0px",
                      }}
                    >
                      El servicio se suspenderá hasta:
                    </Typography>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "5px 0px",
                        }}
                      >
                        <DateRangeIcon
                          sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                        />
                        <div style={{ width: "100%", paddingLeft: 5 }}>
                          <div style={{ display: "flex" }}>
                            <Typography sx={{ color: "#6e7a76", width: "12%" }}>
                              Fecha:
                            </Typography>

                            <DatePicker
                              id="date"
                              selected={selectedSuspendFinishtDate}
                              onChange={handleFinishDateSuspendChange}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="dd/mm/aaaa"
                              showYearDropdown
                              scrollableYearDropdown
                              className={classes.dateSelector}
                              locale={es}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "5px 0px",
                        }}
                      >
                        <AccessTimeIcon
                          sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                        />

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Typography
                            style={{
                              color: "#6e7a76",
                              marginLeft: 5,
                              fontFamily: "Roboto",
                              width: "12%",
                            }}
                          >
                            Horario:
                          </Typography>

                          <div>
                            <input
                              id="appt-time"
                              type="time"
                              name="appt-time"
                              value={finishSuspendTime}
                              onChange={(event) =>
                                handleFinishTimeSuspendChange(
                                  event.target.value,
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {finishDateSuspendError && (
                      <Grid
                        item
                        xs={6}
                        style={{
                          display: "flex",
                          paddingTop: 10,
                          alignItems: "center",
                          fontWeight: "bold",
                          color: "#AD0707",
                        }}
                      >
                        {textError}
                      </Grid>
                    )}
                  </div>
                </div>
              )}
              {((checkSuspendNotification && editedType === "MAINTENANCE") ||
                editedType === "SERVICE_SUSPENSION") && (
                <div style={{ width: "100%" }}>
                  <Typography
                    style={{
                      color: "#6e7a76",
                      marginTop: 10,
                      marginLeft: 5,
                      marginBottom: 5,
                      fontFamily: "Roboto",
                    }}
                  >
                    Tipo de condición:
                  </Typography>
                  <SelectNotificationConditions
                    notificationCondSelect={notificationCondSelect}
                    handleChange={handleChangeNotificationConditions}
                  />
                  {typeNotifCondError && (
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        paddingTop: 10,
                        alignItems: "center",
                        fontWeight: "bold",
                        color: "#AD0707",
                      }}
                    >
                      {textError}
                    </Grid>
                  )}
                  <Typography
                    style={{
                      color: "#6e7a76",
                      marginTop: 10,
                      marginLeft: 5,
                      marginBottom: 5,
                      fontFamily: "Roboto",
                    }}
                  >
                    Grupos de estudios:
                  </Typography>
                  <SelectSuborgGroups
                    suborganizationGroupSelect={suborganizationGroupSelect}
                    handleChange={handleChangeSuborgGroup}
                  />
                  {suborgGroupError && (
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        paddingTop: 10,
                        alignItems: "center",
                        fontWeight: "bold",
                        color: "#AD0707",
                      }}
                    >
                      {textError}
                    </Grid>
                  )}
                </div>
              )}
              <Grid item xs={8} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    color: "#6e7a76",
                    marginTop: 10,
                    marginLeft: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto",
                  }}
                >
                  Aplicación:
                  <FormControlLabel
                    label="ME"
                    control={
                      <Checkbox
                        size="small"
                        disabled
                        checked
                        value="ME"
                        style={{
                          marginLeft: "10%",
                          color: "#696564",
                          "&.MuiChecked": {
                            color: "#696564",
                          },
                        }}
                      />
                    }
                  />
                </Typography>
              </Grid>

              <Grid item xs={6} style={{ paddingTop: 3 }}>
                <Typography
                  style={{
                    color: "#6e7a76",
                    marginTop: 10,
                    marginLeft: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto",
                  }}
                >
                  Canal de comunicación:
                  {children}
                </Typography>
              </Grid>
              {plataformError && (
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    paddingTop: 10,
                    alignItems: "center",
                    fontWeight: "bold",
                    color: "#AD0707",
                  }}
                >
                  {textError}
                </Grid>
              )}
            </Grid>
            <Box className={classes.buttons}>
              <ButtonConfirm
                handleUpdateNotification={handleUpdateNotification}
              />
            </Box>
          </>
        )}
      </Grid>
    </div>
  )
}

function ButtonConfirm({
  showCircularProgress,
  isError,
  handleUpdateNotification,
}) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!showCircularProgress && !isError) {
      try {
        await handleUpdateNotification()
        setProgressComplete(true)
      } catch (error) {}
    }
  }

  useEffect(() => {
    if (isError) {
      setProgressComplete(false)
    }
  }, [isError])

  return (
    <div>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ""
        }`}
        disabled={isProgressComplete && showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography
            className={classes.confirmButtonTypography}
            variant="contained"
          >
            Confirmar modificación
          </Typography>
        )}
      </button>
    </div>
  )
}
